<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    rounded
                    :loading="submitting"
                    :disabled="submitting || loading"
                    v-bind="attrs"
                    v-on="on"
                    block
                >
                    Profiel insturen
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="text-h5">
                    Gegevens controleren
                </v-card-title>
                <v-card-text class="my-4">
                    Zijn de gegevens voor je profiel volledig ingevuld?<br>
                    Na het insturen van je profiel kun je deze niet meer zelf aanpassen.
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="secondary"
                        @click="dialog = false"
                        text
                    >
                        Terug
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="submit"
                    >
                        Profiel definitief insturen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    data () {
        return {
            dialog: false,
        }
    },
    props: {
        submitting: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        submit () {
            this.dialog = false;
            this.$emit('submit')
        }
    }
}
</script>
